import { Organisation, OrganisationEmailStatusDTO } from '../api/schemas/schema'
import { compareByDate } from './dateHelper'

/**
 * Statusen kundregistret arbetar mot: kvitton per kund plus brytpunkten för kvittoföringen.
 *
 * Avsiktligt fri från API-anrop — reglerna nedan avgör vilket mail en kund får och ska gå att
 * testa utan att dra in hela klienten.
 */
export interface IWelcomeEmailStatus {
   trackingStartedAt?: string
   byOrganisationId: Map<string, OrganisationEmailStatusDTO>
}

export const emptyWelcomeEmailStatus: IWelcomeEmailStatus = { trackingStartedAt: undefined, byOrganisationId: new Map() }

/**
 * Kunder som skapades innan kvittoföringen började har vi ingen historik för. De behandlas som
 * redan onboardade — annars skulle hela det befintliga kundregistret visas som "ej skickat" och
 * sluta få uppdateringsmail den dagen funktionen driftsätts.
 */
export const wasCreatedBeforeTracking = (organisation: Organisation, status: IWelcomeEmailStatus) =>
   !!status.trackingStartedAt && !!organisation?.created && compareByDate(organisation.created, status.trackingStartedAt) < 0

/** Har kunden fått sitt välkomstmail — antingen kvitterat, eller för att den fanns före brytpunkten. */
export const hasWelcomeEmailBeenSent = (organisation: Organisation, status: IWelcomeEmailStatus) =>
   status.byOrganisationId.has(organisation?.id) || wasCreatedBeforeTracking(organisation, status)
